import * as React from 'react';
import OEITable from './OEITable';
import { doNothing } from './OEIUtils';
import config from "../configurations/config";
import { fetchAccountDataWithIntgAccId, deleteAccountMapping } from './APIService'
import { CLIENT_NAME, EMPTY, LOADING, SYSTEM_NAME1, SYSTEM_NAME2, SYSTEM_NAME4, SYSTEM_NAME5 } from './Constants';
const columns = [
  { id: 'systemName', label: 'Mapped System', align: 'left', edit: false, width: '30%', button: false },
  { id: 'createdDate', label: 'Date Created', button: false, edit: false, width: '30%' },
  { id: 'updatedDate', label: 'Date last updated', button: false, edit: false, width: '30%' },
  { id: 'Manage', label: EMPTY, buttonLabel: 'Edit', button: true, edit: false, width: '10%', align: 'left' }
];
export default function ManageAcct(props) {

  const [newAccountData, setnewAccountData] = React.useState([]);
  const [errorMessage, seterrorMessage] = React.useState(EMPTY);
  const [accountMappings, setAccountMappings] = React.useState([]);
  const [checked, setChecked] = React.useState(false);
  const [closePopover, setClosePopover] = React.useState(true);
  const [message, setMessage] = React.useState(LOADING);
  const [errors, setErrors] = React.useState({ error1: EMPTY, error2: EMPTY, error3: EMPTY });

const formatDate=(dateString) => {
const date = new Date(dateString);
const options = { year: "numeric", month: "long", day: "numeric" };
const formatted = date.toLocaleDateString("en-US", options);
  return formatted==="Invalid Date" ? EMPTY : formatted;
}

  const getAccountMappings = () => {
    const newArr = accountMappings.map((element, index) => {
      return { ...element, id: element.systemIdInfo,  createdDate: formatDate(element.createTimestamp),updatedDate: formatDate(element.updateTimestamp)};
    });
    return newArr;
  }
  React.useEffect(function () {
    fetchAccountMappingData(props.match.params.id);
  }, [])
  const fetchAccountMappingData = (id) => {
    fetchAccountDataWithIntgAccId(id).then(response => {
      response.length === 0 ? setMessage('There are no accounts mapped') : setMessage(EMPTY)
      setAccountMappings(response);
    })
  };
  const createAccountMapping = (e) => {
    const integrationAccountId = props.match.params.id
    const passportOrReports = newAccountData.systemName === SYSTEM_NAME4 || newAccountData.systemName === SYSTEM_NAME5
    if ((passportOrReports) && (!checked)) {
      setErrors({ ...errors, error2: "Enable toggle to create system mapping" });
    } else if ((!passportOrReports) && ((newAccountData.systemIntgId === undefined) || (newAccountData.systemIntgId === EMPTY))) {
      setErrors({ ...errors, error2: "This Field is required." });
    }
   else if(newAccountData.systemName===SYSTEM_NAME4 && newAccountData.passportData.length<1){
      setErrors({...errors,error6:"Passport Template is required"})
    } else if( newAccountData.systemName === SYSTEM_NAME2 &&newAccountData.childAccessEnable === "Single" && (newAccountData.subAccountIds === undefined || newAccountData.subAccountIds.length < 1)){ 
      setErrors({ ...errors, error9: "Atleast One Child Account is Required." });
    }
    else {
      var conf=EMPTY
      var list=[];
      if(newAccountData.systemName===SYSTEM_NAME4 && newAccountData.passportData.length>0){
        newAccountData.passportData.map(item=>{
          list.push({  passportTemplateMappingName:item.PassportTemplateMappingName,
            eventTypes: item.checkedList,
            fileName: item.fileName,
            configuration: item.pptConfiguration})
          })
        var conf= JSON.stringify(list)
      }
      fetch(config.apiGateway.URL + "accounts/accountmapping", {
        method: "POST",
        headers: { 'X-OEX-Int-Authorization': sessionStorage.getItem('idToken') },
        body: JSON.stringify({
           integrationAccountId: integrationAccountId,
            systemName: newAccountData.systemName,
            systemIntgId: newAccountData.systemIntgId,
            systemIdInfo: integrationAccountId + '/' + newAccountData.systemName,
            passportConfiguration:conf,
            parentAccessEnable: newAccountData.parentAccessEnable? newAccountData.parentAccessEnable : 'Enabled',
            childAccessEnable: newAccountData.childAccessEnable? newAccountData.childAccessEnable : 'All',
            passportConfigurationFileName:( newAccountData.systemName === SYSTEM_NAME4&& (newAccountData.pptConfiguration!==undefined && newAccountData.pptConfiguration!==EMPTY  ))?newAccountData.fileName:EMPTY,
            subAccountIds:newAccountData.systemName === SYSTEM_NAME2 && newAccountData.childAccessEnable==='Single'?newAccountData.subAccountIds:[]})
          }).then(response => response.json())
        .then(data => {
          if (data.message === 'Account mapping with given system is already exists.') {
            setErrors({ ...errors, error1: "Account mapping with given system is already exists." });
          }
          else if(data.message === 'Account mapping with given system and mapped accountId is already exists.'){
            setErrors({ ...errors, error2: "Account mapping with given system and mapped accountId is already exists." });

          }
          else {
            setnewAccountData({ systemName: SYSTEM_NAME1 })
            setClosePopover(true)
            setErrors([]);
            setChecked(false)
            fetchAccountMappingData(integrationAccountId)
          }
        })
        .catch((error) => {
          if (error.response !== undefined) {
            if (error.response.status === 403 || error.response.status === 400 || error.response.status === 401) {
              alert("session expired");
            }
          }
        });
    }
  }
const getSubAccountIds = (array1, aray2) => {
  return array1.subAccountIds.filter(id => !aray2.subAccountIds.includes(id));
};

  const editAccountMapping = (row) => {
    if(newAccountData.systemName===SYSTEM_NAME4 && newAccountData.passportData.length<1){
      setErrors({...errors,error6:"Passport Template is required"})
    }else
   if (!( row.systemName === "reports")) {
      if (row.systemIntgId === EMPTY&&!( row.systemName === SYSTEM_NAME4)) {
        setErrors({ ...errors, error2: "This Field is required." });
      }  else if( newAccountData.systemName === SYSTEM_NAME2 &&newAccountData.childAccessEnable === "Single" && (newAccountData.subAccountIds === undefined || newAccountData.subAccountIds.length < 1)){ 
      setErrors({ ...errors, error9: "Atleast One Child Account is Required." });
    }else {
        var conf=EMPTY
        var list=[];
        if(newAccountData.systemName===SYSTEM_NAME4 && newAccountData.passportData.length>0){
          newAccountData.passportData.map(item=>{
            list.push({  passportTemplateMappingName:item.PassportTemplateMappingName,
              eventTypes: item.checkedList,
              fileName: item.fileName,
              configuration: item.pptConfiguration})
            })
          var conf= JSON.stringify(list)
        }
          fetch(config.apiGateway.URL + "accounts/accountmapping", {
          method: "PUT",
          headers: { 'X-OEX-Int-Authorization': sessionStorage.getItem('idToken') },
          body: JSON.stringify({ integrationAccountId: row.integrationAcctId,
             systemName: row.systemName, 
             systemIntgId: newAccountData.systemIntgId,
             systemIdInfo: newAccountData.systemIdInfo,
             passportConfiguration: conf,
            //  passportConfiguration: ( row.systemName === SYSTEM_NAME4&& (row.pptConfiguration!==undefined&&row.pptConfiguration!==EMPTY))?row.pptConfiguration : EMPTY,
            passportConfigurationFileName: ( row.systemName === SYSTEM_NAME4&& (row.pptConfiguration!==undefined&&row.pptConfiguration!==EMPTY))?row.fileName :EMPTY,
            updatedMainAcountId:row.systemIntgId===newAccountData.systemIntgId? null : row.systemIntgId,
            parentAccessEnable: newAccountData.parentAccessEnable? newAccountData.parentAccessEnable : 'Enabled',
            childAccessEnable: newAccountData.childAccessEnable? newAccountData.childAccessEnable : 'All',
            subAccountIds:newAccountData.systemName === SYSTEM_NAME2 && newAccountData.childAccessEnable==='Single'?newAccountData.subAccountIds:[],
            removedSubAccountIds: newAccountData.systemName === SYSTEM_NAME2 && newAccountData.childAccessEnable==='Single'?getSubAccountIds(row,newAccountData):[],
            addedSubAccountIds: newAccountData.systemName === SYSTEM_NAME2 && newAccountData.childAccessEnable==='Single'?row.subAccountIds.length===0?newAccountData.subAccountIds:getSubAccountIds(newAccountData,row):[],
            createTimestamp: row.createTimestamp,
            clientName: row.clientName  })
        }).then(response => {
          setClosePopover(true)
          fetchAccountMappingData(row.integrationAcctId)
        })
      }
    }
  }
  const deleteSystemMapping = (e) => {
   const systemInfo=e.systemName===SYSTEM_NAME2?e.systemIdInfo+e.systemName:e.systemIdInfo
   deleteAccountMapping(systemInfo).then(response => {
      setClosePopover(true)
      fetchAccountMappingData(e.integrationAcctId)
    }
    )
  }
  const removeMainItem=(e)=>{
   let data= newAccountData.passportData;
    var indexid;
     data.map(item=>{
       if(item.PassportTemplateMappingName===e.PassportTemplateMappingName){
       indexid=data.indexOf(item);
       data.splice(indexid,1);
       }
     })
 setnewAccountData({...newAccountData,passportData:data});
  }
  return (
    <>
      <OEITable removeMainItem={removeMainItem}match={props.match} tabClicked='systemmapping' history={props.history}
        delete={deleteSystemMapping} headerStyle='sticky-header1' tableHeaderStyle='table-header1'
        closePopover={closePopover} setClosePopover={setClosePopover} onclick={createAccountMapping}
        checked={checked} setChecked={setChecked} setGenerate={doNothing} setEmail={doNothing} errors={errors} setErrors={setErrors}
        errorMessage={errorMessage} setErrorMessage={seterrorMessage} rowData={getAccountMappings()}
        newData={newAccountData} setNewData={setnewAccountData} columns={columns} submenu='true' newAction='System Mapping'
        tableHeadings={sessionStorage.systemName} edit={editAccountMapping} message={message}></OEITable>
    </>
  )
};